export const versions = {
  version: "1.0.183",
  revision: "675175a71",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5117-g675175a71-dirty",
    hash: "g675175a71",
    distance: 5117,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5117-g675175a71-dirty",
    semverString: "1.0.183+5117.g675175a71.dirty"
  }
};
